// Pagination limit
export const LIMIT: number = 10

export const YOUTUBE_LINK: string = "https://www.youtube.com/channel/UCeKNQJpSMBPbGlbqWOxDr0A"

export const FACEBOOK_LINK: string = "https://www.facebook.com/POKROKdigital-109065457134417/"
